import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles, makeStyles, useTheme } from '@material-ui/core/styles';

import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import { LastPage, AllInclusive, Add, MoreVert, Schedule, Block, Edit, Delete, People, CheckCircleOutline, NotInterested, Cancel, DepartureBoard, Commute, TurnedInNot, EmojiTransportation, AmpStories, VpnKey, TramRounded, Visibility, VisibilityOff } from '@material-ui/icons';


import {
  TableRow,
  TablePagination,
  TableFooter,
  TableContainer,
  TableCell,
  TableBody,
  Table,
  TableHead,
  Button,
  IconButton,
  Paper,
  Typography,
  Toolbar,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  AppBar,
  TextField,
  FormControlLabel,
  Checkbox,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Menu,
  TextareaAutosize,
  LinearProgress,
  FormHelperText,
  CircularProgress,
  Chip,
  Grid,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  ListItemSecondaryAction,
  Switch,
  useMediaQuery, Stepper, Step, StepLabel,
  OutlinedInput,
  InputAdornment,
  Badge

} from "@material-ui/core";

import Autocomplete from '@material-ui/lab/Autocomplete';

import { withLocalize, Translate } from "react-localize-redux";
import MUIDataTable from "mui-datatables";
import API from './api';

import { useSnackbar } from 'notistack';
import { setDayWithOptions } from 'date-fns/fp';

// import * as userInfo from "./login_info.js";

import UserInfo from "./login_info";

import axios from 'axios';


import { TransportService, AdminService, ReportingService } from "./../../utils/web_config_2";
import { pink } from '@material-ui/core/colors';
import Skeleton from '@material-ui/lab/Skeleton';
import { Link } from 'react-router-dom';

import MaskedInput from "react-text-mask";

import ID from '../../assets/svg/id.svg';
import { unlockUser } from '../../utils/unlock-user';
import { useAuthUser } from '../../hooks/useUserToken';

const StyledBadge = withStyles((theme) => ({
  badge: {
    backgroundColor: '#44b700',
    color: '#44b700',
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: '$ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0,
    },
  },
}))(Badge);

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    flexFlow: 1,
    [theme.breakpoints.up('sm')]: {
      marginLeft: 250,
    }
  },
  btn: {
    textTransform: "capitalize",

  },
  formTitle: {
    flexGrow: 1,
  },
  chip: {
    margin: theme.spacing(0.5),
    textTransform: "capitalize"
  }

}));

// mask NID 

const TextMaskCustom = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={inputRef}
      mask={[/[0-9]/, ' ', /[0-9]/, /\d/, /\d/, /\d/, ' ', /[0-9]/, ' ', /[0-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, ' ', /[0-9]/, ' ', /[0-9]/, /\d/]}
      placeholderChar={'\u2000'}
      showMask
    />
  );
}

TextMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};




function UserRoute() {
  const classes = useStyles1();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [operatorData, setOperatorData] = useState({});
  const [userMessage, setUserMessage] = useState("Loading...");
  const [routeMessage, setRouteMessage] = useState("Loading...");
  const [outletMessage, setOutletMessage] = useState("Laoding...");
  const Theme = useTheme();
  const matches = useMediaQuery(Theme.breakpoints.up("sm"));

  const authedUser = useAuthUser()


  // stop table 


  const canUnlockeDayClosedPOSUser = authedUser?.permissions?.find(priviledge => priviledge.name == "CAN_UNLOCK_DAY_CLOSED_POS_USER")?.id

  const columns = [
    {
      name: "id",
      label: "id",
      options: {
        display: false,
        filter: true,
        sort: true,
      }
    },
    {
      name: "adminId",
      label: "adminId",
      options: {
        display: false,
        filter: true,
        sort: true,
      }
    },
    {
      name: "names",
      label: <Translate id="operator_pos_user_route.user_table.names" />,
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "username",
      label: "Username",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "user_type",
      label: <Translate id="operator_pos_user_route.user_table.user_type" />,
      options: {
        filter: true,
        sort: false,
      }
    },
    {
      name: "status",
      label: <Translate id="operator_pos_user_route.user_table.status" />,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          if (value == "ACTIVE") {
            return (
              <Chip
                variant="outlined"
                size="small"
                color="primary"
                icon={<CheckCircleOutline />}
                label={value}
              />

            );
          } else {
            return (
              <Chip
                variant="outlined"
                size="small"
                color="secondary"
                icon={<NotInterested />}
                label={value}
              />

            );
          }

        }
      }
    },
    ...(canUnlockeDayClosedPOSUser ? [
      {
        name: "accountLockedUntil",
        label: "Locked Until",
        options: {
          customBodyRender: (value, { rowData }, updateValue) => {
            if (!value) {
              return (
                <div>Active (Not Locked)</div>
              )
            }

            if (Date.now() > new Date(value).getTime()) {
              return (
                <div>Active</div>
              )
            } else {
              return (
                <div>
                  <Button
                    className={classes.btn}
                    size="small"
                    onClick={async () => {
                      await unlockUser(rowData[3])
                      updateValue(Date.now())
                    }}
                    variant="contained"
                    color="primary"
                    disableElevation={true}>
                    Unlock
                  </Button>
                </div>
              )
            }
          }
        }
      }
    ] : [])
  ];

  const options = {
    textLabels: {
      body: {
        noMatch: userMessage
      },
    },
    filterType: 'checkbox',
    download: true,
    responsive: "standard",
    selectableRows: "single",
    rowsPerPage: 10,
    elevation: 0,
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
      <Box>


        <Chip
          className={classes.chip}
          variant="outlined"
          size="medium"
          color="secondary"
          icon={<VpnKey />}
          label={"Reset Password"}
          onClick={() => {
            console.log("Reset password");
            var adminId = displayData[selectedRows.data[0]['index']]['data'][1];
            console.log("admin id", adminId);
            setUserId(adminId);
            setResetDialog(true);
          }}
        />

        <Chip
          className={classes.chip}
          variant="outlined"
          size="medium"
          color="secondary"
          icon={<Commute />}
          label={"View route"}
          onClick={() => {
            console.log("view routes");
            var id = displayData[selectedRows.data[0]['index']]['data'][0];
            console.log("pos", id);
            get_routes(id);
          }}
        />

        <Chip
          className={classes.chip}
          variant="outlined"
          size="medium"
          color="secondary"
          icon={<TurnedInNot />}
          label={"View outlets"}
          onClick={() => {
            console.log("view outlets");
            var id = displayData[selectedRows.data[0]['index']]['data'][0];
            get_outelets(id);
          }}
        />

        <Chip
          className={classes.chip}
          variant="outlined"
          size="medium"
          color="primary"
          icon={<Add />}
          label={"Add route"}
          onClick={() => {

            var id = displayData[selectedRows.data[0]['index']]['data'][0];
            setUserId(id);
            setAssignDialog(true);

          }}
        />

      </Box>
    ),
  };



  useEffect(() => {

    var data = {};
    const data1 = localStorage.getItem("nx_op");
    if (data1 != null) {
      data = JSON.parse(data1);
    }
    console.log(data.token);

    setOperatorData(data);
    get_users(data.token);
    get_roles(data.token);
    get_route(data.token);
    get_outlet(data.token);
  }, []);

  /// get outlets

  const [Ioutlets, setIOutlets] = useState([]);
  const get_outlet = (token) => {
    axios.defaults.baseURL = new TransportService().BASE_URL;
    const outletInstance = axios.create(new TransportService().setHeaders(token));
    outletInstance.get('/api/v1/branching/getOutletsByOrganization/' + new UserInfo().ID)
      .then(res => {
        var objs = res.data;
        setIOutlets(objs);
      })
      .catch(err => {

      })
  }



  /// fetch users 



  const [users, setUsers] = useState([]);

  const [loadUser, setUserLoad] = useState(false);
  const get_users = (token) => {
    setUserMessage("Loading...");
    setUserLoad(true);
    axios.defaults.baseURL = new TransportService().BASE_URL;
    const usersInstance = axios.create(new TransportService().setHeaders(token));
    usersInstance.get('/api/v1/integrations/getUsersByOrganization/' + new UserInfo().ORG_ID
    ).then(res => {
      setUserLoad(false);
      console.log("pos users", res.data);
      var d = res.data;
      if (d.length == 0) {
        setUserMessage("No Users available");
      } else {
        setUserMessage("");
        var dd = d.filter((x) => x.user_type == "POS_USER" || x.user_type === "POS_AGENT");
        if (dd.length == 0) {
          setUserMessage("No Users available");
        } else {
          setUserMessage("");
          setUsers(dd);
        }

      }
    }).catch(err => {
      setUserMessage("Something went wrong");
      setUserLoad(false);

      enqueueSnackbar(err.message, {
        variant: 'error',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
        },
      });
      console.log(err);
    });
  }

  /// fetch routes

  const [route, setRoute] = useState([]);
  const get_route = (token) => {
    axios.defaults.baseURL = new TransportService().BASE_URL;
    const routesInstance = axios.create(new TransportService().setHeaders(token));
    routesInstance.get('/api/v1/integrations/getRoutesByOrganization/' + new UserInfo().ORG_ID)
      .then(res => {
        var objs = res.data;
        var n_objs = objs.filter((o) => o.status != "CANCELED");
        setRoute(n_objs);
      })
      .catch(err => {

      });
  }


  // fetch route outlet 

  const [routeOutlet, setRouteOutlet] = useState([]);
  const get_route_outlet = (id) => {
    axios.defaults.baseURL = new TransportService().BASE_URL;
    const routeOutletInstance = axios.create(new TransportService().setHeaders(operatorData.token));
    routeOutletInstance.get('/api/v1/branching/findRouteOutletsByRoute/' + id)
      .then(res => {
        console.log(res.data);
        setRouteOutlet(res.data);
      })
      .catch(err => {

      })
  }


  // fetch roles

  const [roles, setRoles] = useState([]);
  const get_roles = (token) => {

    axios.defaults.baseURL = new AdminService().BASE_URL;
    const rolesInstance = axios.create(new AdminService().setHeaders(token));
    rolesInstance.get('/api/v1/role/organization/' + new UserInfo().ORG_ID
    ).then(res => {
      setRoles(res.data.data);
    }).catch(err => {
      console.log(err);
    })

  }




  //   user route dialog 



  const [routeDialog, setDialogRoute] = useState(false);

  // user route 
  const [routeLoad, setRouteLoad] = useState(false);
  const [routes, setRoutes] = useState([]);
  const get_routes = (id) => {
    setRouteLoad(true);
    setDialogRoute(true);
    setRouteMessage("Loading...");
    axios.defaults.baseURL = new TransportService().BASE_URL;
    const routeInstance = axios.create(new TransportService().setHeaders(operatorData.token));
    routeInstance.get(new TransportService().FIND_USER_ROUTE_OUTLET_BY_USER + id
    ).then(res => {
      setRouteLoad(false);
      var d = res.data.data;
      console.log(d);

      if (d.length == 0) {
        setRouteMessage("No route assigned to this user!");
      } else {
        var json = [];
        d.map((r) => {
          if (r['route_outlet']['route'] != null) {
            json.push(r);
          }
        });
        setRouteMessage("");
        setRoutes(json);
      }




    }).catch(err => {
      setRouteLoad(false);
      enqueueSnackbar(err.message, {
        variant: 'error',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
        },
      });
    });
  }


  // user outlet dialog 


  const [outletDialog, setOutletDialog] = useState(false);


  // user outlet 


  const [outletLoad, setOutletLoad] = useState(false);
  const [outlets, setOutlets] = useState([]);
  const get_outelets = (id) => {
    setOutletLoad(true);
    setOutletDialog(true);
    setOutletMessage("Loading...");
    axios.defaults.baseURL = new TransportService().BASE_URL;
    const outletInstance = axios.create(new TransportService().setHeaders(operatorData.token));
    outletInstance.get('/api/v1/branching/findOutlesByUser/' + id
    ).then(res => {
      setOutletLoad(false);
      var d = res.data;
      if (d.length == 0) {
        setOutletMessage("No outlet available");
      } else {
        setOutletMessage("");
        setOutlets(res.data);
      }
    }).catch(err => {
      setOutletLoad(false);
      enqueueSnackbar(err.message, {
        variant: 'error',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
        },
      });
    });
  }


  //  new POS user


  const [posStep, setPosStep] = useState(0);


  const [dialogStep, setDialogStep] = useState(false);

  const [activeStep, setActiveStep] = useState(0);
  const steps = ['Register POS User', 'Assign Outlet/Route'];

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const [newLoad, setNewLoad] = useState(false);
  const [email, setEmail] = useState({ value: "", error: "" });
  const [Fname, setFname] = useState({ value: "", error: "" });
  const [Lname, setLname] = useState({ value: "", error: "" });
  const [gender, setGender] = useState({ value: "", error: "" });
  const [userName, setUsername] = useState({ value: "", error: "" });
  const [nid, setNid] = useState({ value: "", error: "" });
  const [password, setPassword] = useState({ value: "", error: "" });
  const [phone, setPhone] = useState({ value: "", error: "" });
  const [pin, setPin] = useState({ value: "1234", error: "" });
  const [userType, setUserType] = useState({ value: "", error: "" });
  const [role, setRole] = useState({ value: 0, error: "" });

  const new_user = () => {
    if (email.value === "") {
      setEmail({ value: "", error: "Enter email" });
    } else if (Fname.value === "" || Fname.value.length < 3) {
      setFname({ value: "", error: "Enter first name" });
    } else if (Lname.value === "" || Lname.value.length < 3) {
      setLname({ value: "", error: "Enter lastname" });
    } else if (gender.value === "") {
      setGender({ value: "", error: "Select gender" });
    } else if (userName.value === "" || userName.value.length < 3) {
      setUsername({ value: "", error: "Enter Username" });
    }

    // else if(password.value===""){
    //   setPassword({value:"",error:"Enter password"});
    // }

    else if (phone.value === "") {
      setPhone({ value: "", error: "Enter phone" });
    } else if (role.value == 0) {
      setRole({ value: 0, error: "Select role" });
    } else {
      setNewLoad(true);
      axios.defaults.baseURL = new AdminService().BASE_URL;

      const newInstance = axios.create(new AdminService().setHeaders(operatorData.token));
      newInstance.post('/api/v1/user/register',
        {
          "organization_id": new UserInfo().ORG_ID,
          "role_id": role.value,
          "user_email": email.value,
          "user_first_name": Fname.value,
          "user_gender": gender.value,
          "user_last_name": Lname.value,
          "user_name": userName.value,
          "user_nid": NID.value,
          "user_phone": phone.value,
          "user_type": "POS_USER"
        }
      ).then(res => {

        var dd = res.data.data;

        get_user_id(dd['user_id']);

        setNID({ value: "", error: "" });
        setPhoto("");

        // var obj={
        // user_id:dd['user_id'],
        // user_email:dd['user_email'],
        // next_password_expiry_date:dd['next_password_expiry_date'],
        // names:dd['user_first_name']+" "+dd['user_last_name'],
        // user_fname:dd['user_first_name'],
        // user_lname:dd['user_last_name'],
        // user_gender:dd['user_gender'],
        // user_phone:dd['user_phone'],
        // user_nid:dd['user_nid'],
        // user_type:dd['user_type'],
        // user_status:dd['user_status'],
        // role_id:dd['role_id'],
        // organization_id:dd['organization_id'],
        // created_by_user_id:dd['created_by_user_id'],
        // updated_by_user_id:dd['updated_by_user_id'],
        // created_date:dd['created_date'],
        // mod_date:dd['mod_date'],
        // last_login_date:dd['ast_login_date']};

        // var u=users;
        // u.unshift(obj);
        // setUsers(u);




        // setNewLoad(false);



        enqueueSnackbar('New user added successifuly!', {
          variant: 'success',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
          },
        });


        setFname({ value: "", error: "" });
        setLname({ value: "", error: "" });


      }).catch(err => {
        setNewLoad(false);
        console.log(err);

        if (err.message) {
          enqueueSnackbar(err.message, {
            variant: 'error',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
            },
          });
        }


        if (err.response) {
          enqueueSnackbar(err.response.data.message, {
            variant: 'error',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
            },
          });
        }

      });
    }
  }


  // get user id from transport micro-service


  const [userId, setUserId] = useState(0);

  const get_user_id = (id) => {
    axios.defaults.baseURL = new TransportService().BASE_URL;
    const userInstance = axios.create(new TransportService().setHeaders(operatorData.token));
    userInstance.get('/api/v1/integrations/getUserByAdminId/' + id)
      .then(res => {
        var obj = res.data.data;

        setUserId(obj.id);

        var u = users;
        u.unshift(obj);
        setUsers(u);
        handleNext();
        setNewLoad(false);
      })
      .catch(err => {

      });
  }


  // assign route dialog 

  const [assignDialog, setAssignDialog] = useState(false);



  // assign user outlet and route 

  const [routeOutletId, setRouteOutletId] = useState({ value: 0, error: "" });

  const [assignLoad, setAssignLoad] = useState(false);

  const assign_user_route = () => {
    console.log("== route outlet id ==", routeOutletId.value);
    console.log("== user id ==", userId);
    setAssignLoad(true);
    axios.defaults.baseURL = new TransportService().BASE_URL;
    const assignInstance = axios.create(new TransportService().setHeaders(operatorData.token));
    assignInstance.put('/api/v1/branching/associateUserToRouteAndOutlet', {
      "comment": "string",
      "route_outlet_id": routeOutletId.value,
      "user_id": userId
    })
      .then(res => {
        setAssignLoad(false);
        setAssignDialog(false);
        enqueueSnackbar('Route outlet assigned successfuly!', {
          variant: 'success',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
          },
        });

        setDialogStep(false);
        setActiveStep(0);
        setPosStep(0);
        setManually(false);

      })
      .catch(err => {
        setAssignLoad(false);

        if (err.response) {
          enqueueSnackbar(err.response.data.message, {
            variant: 'error',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
            },
          });
        }


        if (err.message) {
          enqueueSnackbar(err.message, {
            variant: 'error',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
            },
          });
        }



      });

  }



  // reset password 

  const [resetLoad, setResetLoad] = useState(false);
  const [resetDialog, setResetDialog] = useState(false);

  const [success, setSuccess] = useState(false);
  const [resetMessage, setResetMessage] = useState("");
  const reset_password = () => {
    setResetLoad(true);
    axios.defaults.baseURL = new AdminService().BASE_URL;
    const resetInstance = axios.create(new AdminService().setHeaders(operatorData.token));
    resetInstance.put('/api/v1/user/pos/resetPin/' + userId)
      .then(res => {
        var obj = res.data;
        setSuccess(true);
        setResetMessage(obj.data);
        setResetLoad(false);
      })
      .catch(err => {

        setResetLoad(false);
        if (err.response) {
          enqueueSnackbar(err.response.data.message, {
            variant: 'error',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
            },
          });
        }

        if (err.message) {
          enqueueSnackbar(err.message, {
            variant: 'error',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
            },
          });
        }


      });

  }


  /// show password 


  const [showPassword, setShowPassword] = useState(false);




  //////////// to be done later ////////



  /// add more than one route to pos user


  const [assignMoreLoad, setAssignMoreLoad] = useState(false);


  const [outletId, setOutletId] = useState({ value: 0, error: "" });
  const [routeIds, setRouteIds] = useState({ value: [], error: "" });

  const assign_routes = () => {
    if (routeIds.length == 0) {
      enqueueSnackbar("Select atleast one route", {
        variant: 'error',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
        },
      });
    } else if (outletId.value == 0) {
      setOutletId({ value: 0, error: "Choose outlet" })
    } else {
      console.log("outletId.value", outletId.value);
      console.log("routeIds.value", routeIds.value);
      console.log("user_id", userId);
      setAssignMoreLoad(true);
      axios.defaults.baseURL = new TransportService().BASE_URL;
      const assignInstance = axios.create(new TransportService().setHeaders(operatorData.token));
      assignInstance.put('/api/v1/branching/associateUserToRoutesAndOutlet',
        {
          "comment": "Ok",
          "outlet_id": outletId.value,
          "route_ids": routeIds.value + "",
          "user_id": userId
        })
        .then(res => {
          enqueueSnackbar("Routes assigned successful", {
            variant: 'success',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
            },
          });
          setAssignDialog(false);
          setAssignMoreLoad(false);

        })
        .catch(err => {
          if (err.message) {
            enqueueSnackbar(err.message, {
              variant: 'error',
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'right',
              },
            });
          }

          if (err.response) {
            enqueueSnackbar(err.response.data.message, {
              variant: 'error',
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'right',
              },
            });
          }
          setAssignMoreLoad(false);
        });

    }

  }


  // get route by outlet id

  const [loadRoute, setLoadRoute] = useState(false);
  const [routesOutlet, setRoutesOutlet] = useState([]);
  const get_routes_per_outlet = (id) => {
    setLoadRoute(true);
    setRoutesOutlet([]);
    axios.defaults.baseURL = new TransportService().BASE_URL;
    const routeInstance = axios.create(new TransportService().setHeaders(operatorData.token));
    routeInstance.get('/api/v1/branching/geRoutesByOutletI/' + id)
      .then(res => {
        console.log(res.data);
        var objs = res.data;
        var obj_routes = [];
        objs.map((o) => {
          if (o.status != "CANCELED") obj_routes.push(o);
        });
        setRoutesOutlet(obj_routes);
        setLoadRoute(false);

      })
      .catch(err => {
        setLoadRoute(false);
        if (err.message) {
          enqueueSnackbar(err.message, {
            variant: 'success',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
            },
          });

          if (err.response.data.message) {
            enqueueSnackbar(err.response.data.message, {
              variant: 'error',
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'right',
              },
            });
          }
        }

      });
  }



  // get NID info of POS user


  const [photo, setPhoto] = useState("");

  const [NID, setNID] = useState({ value: "", error: "" });
  const [loadInfo, setLoadInfo] = useState(false);
  const get_infos = () => {
    if (NID.value == "") {
      setNID({ value: "", error: "Invalid ID" });
    } else if (NID.length == 16) {
      setNID({ value: "", error: "Invalid ID" });
    }
    else {
      setLoadInfo(true);
      const data = {
        "document_number": NID.value
      };
      axios.defaults.baseURL = new ReportingService().BASE_URL;
      const infoInstance = axios.create(new ReportingService().setHeaders(operatorData.token));
      infoInstance.post(new ReportingService().GET_NID_INFO, data)
        .then(res => {
          setLoadInfo(false);
          var obj = res.data.data;
          if (obj.applicationNumber != null) {
            setFname({ value: obj.foreName, error: "" });
            setLname({ value: obj.surnames, error: "" });
            setPhoto(obj.photo);
            var gender = obj.sex;
            if (gender == "M") {
              setGender({ value: "MALE", error: "" });
            } else if (gender == "F") {
              setGender({ value: "FEMALE", error: "" });
            }

            setPosStep(1);
          } else {
            setNID({ value: "", error: "Invalid NID" });
          }


        })
        .catch(err => {


        });
    }


  }






  // remove route from pos user

  const [removeLoad, setRemoveLoad] = useState(false);
  const remove_route = (id, status, i) => {
    setRemoveLoad(true);
    var st = status == true ? "ACTIVE" : "INACTIVE";
    axios.defaults.baseURL = new TransportService().BASE_URL;
    const removeInstance = axios.create(new TransportService().setHeaders(operatorData.token));
    removeInstance.put(new TransportService().REMOVE_ROUTE_USER,
      {
        "status": st,
        "user_route_outlet_id": id
      }
    ).then(res => {
      var obj = res.data.data;
      var rs = routes;
      rs[i]['status'] = obj['status'];
      setRoutes(rs);
      setRemoveLoad(false);
      if (st == "ACTIVE") {
        enqueueSnackbar("Route enabled", {
          variant: 'success',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
          },
        });
      } else if (st == "INACTIVE") {
        enqueueSnackbar("Route disabled", {
          variant: 'success',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
          },
        });
      }

    })
      .catch(err => {
        setRemoveLoad(false);

        if (err.message) {
          enqueueSnackbar(err.message, {
            variant: 'success',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
            },
          });

          if (err.response.data.message) {
            enqueueSnackbar(err.response.data.message, {
              variant: 'error',
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'right',
              },
            });
          }
        }

      });

  }


  /// continue manually withiout NID

  const [manually, setManually] = useState(false);



  return (
    <div className={classes.root}>
      <Box display="flex">

        <Box display="flex" alignItems="center" mt={2} className={classes.formTitle}>

          <Box mr={1}><DepartureBoard fontSize="large" color="primary" /></Box> <Typography variant="h5" color="default"><b><Translate id="operator_pos_user_route.title" /></b></Typography>

        </Box>
        <Button
          className={classes.btn}
          size="small"
          startIcon={<Add />}
          onClick={() => {
            setDialogStep(true);
          }}
          variant="contained"
          color="primary"
          disableElevation={true}>

          {matches && <Typography noWrap> New POS User</Typography>}

        </Button>

      </Box>

      {/* stops table  */}

      <Box mt={2}>
        {loadUser && <LinearProgress />}
        <MUIDataTable
          title={<Translate id="operator_pos_user_route.title" />}
          data={users}
          columns={columns}
          options={options}
        />
      </Box>

      {/* user route dialog  */}


      <Dialog
        maxWidth="sm"
        fullWidth
        open={routeDialog}
        onClose={() => {
          setDialogRoute(false);
        }}
        aria-labelledby="user_route"
        aria-describedby="user_route"
      >

        <DialogTitle id="user_route">{"POS Route user"}</DialogTitle>
        <DialogContent>
          <DialogContentText >
            {routeLoad ? <Box>
              <Box mt={1} >
                <Grid container >
                  <Grid md={2} lg={2} xs={2} sm={2}>
                    <Skeleton variant="circle" width={40} height={40} />
                  </Grid>
                  <Grid md={10} lg={10} xs={10} sm={10}>
                    <Grid container >
                      <Grid md={12} lg={12} xs={12} sm={12}>
                        <Skeleton animation="wave" />
                      </Grid>
                      <Grid md={12} lg={12} xs={12} sm={12}>
                        <Skeleton animation="wave" />
                      </Grid>
                    </Grid>

                  </Grid>
                </Grid>
              </Box>

              <Box mt={1} >
                <Grid container >
                  <Grid md={2} lg={2} xs={2} sm={2}>
                    <Skeleton variant="circle" width={40} height={40} />
                  </Grid>
                  <Grid md={10} lg={10} xs={10} sm={10}>
                    <Grid container >
                      <Grid md={12} lg={12} xs={12} sm={12}>
                        <Skeleton animation="wave" />
                      </Grid>
                      <Grid md={12} lg={12} xs={12} sm={12}>
                        <Skeleton animation="wave" />
                      </Grid>
                    </Grid>

                  </Grid>
                </Grid>
              </Box>
              <Box mt={1} >
                <Grid container >
                  <Grid md={2} lg={2} xs={2} sm={2}>
                    <Skeleton variant="circle" width={40} height={40} />
                  </Grid>
                  <Grid md={10} lg={10} xs={10} sm={10}>
                    <Grid container >
                      <Grid md={12} lg={12} xs={12} sm={12}>
                        <Skeleton animation="wave" />
                      </Grid>
                      <Grid md={12} lg={12} xs={12} sm={12}>
                        <Skeleton animation="wave" />
                      </Grid>
                    </Grid>

                  </Grid>
                </Grid>
              </Box>

            </Box> :

              <Box>


                {routeLoad == false && routes.length == 0 && "No route Assigned to this user"}
                <List width="100%">
                  {routes.map((r, i) => {
                    return <ListItem>
                      <ListItemAvatar>
                        <EmojiTransportation fontSize="large" />
                      </ListItemAvatar>
                      <ListItemText primary={r['route_outlet']['route']['name']} secondary={r['route_outlet']['route']['total_route_cost'] + " " + r['route_outlet']['route']['currency']['code'] + " | " + r['route_outlet']['outlet']['name']} />
                      <ListItemSecondaryAction>
                        <Switch
                          checked={r['status'] == "ACTIVE" ? true : false}
                          onChange={(e) => {
                            remove_route(r['id'], e.target.checked, i);
                          }}
                          disabled={removeLoad}
                          color="primary"
                          name="checkedB"
                          inputProps={{ 'aria-label': 'primary checkbox' }}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>;
                  })}



                </List>
              </Box>


            }

          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setDialogRoute(false);
          }} variant="outlined" color="secondary" >
            Close
          </Button>

        </DialogActions>
      </Dialog>

      {/* user outlet dialog  */}


      <Dialog
        maxWidth="sm"
        fullWidth
        open={outletDialog}
        onClose={() => {
          setOutletDialog(false);
        }}
        aria-labelledby="user_outlet"
        aria-describedby="user_outlet"
      >


        <DialogTitle id="user_outlet">{"POS Outlet user"}</DialogTitle>
        <DialogContent>
          <DialogContentText >
            {outletLoad ? <Box>
              <Box mt={1} >
                <Grid container >
                  <Grid md={2} lg={2} xs={2} sm={2}>
                    <Skeleton variant="circle" width={40} height={40} />
                  </Grid>
                  <Grid md={10} lg={10} xs={10} sm={10}>
                    <Grid container >
                      <Grid md={12} lg={12} xs={12} sm={12}>
                        <Skeleton animation="wave" />
                      </Grid>
                      <Grid md={12} lg={12} xs={12} sm={12}>
                        <Skeleton animation="wave" />
                      </Grid>
                    </Grid>

                  </Grid>
                </Grid>
              </Box>

              <Box mt={1} >
                <Grid container >
                  <Grid md={2} lg={2} xs={2} sm={2}>
                    <Skeleton variant="circle" width={40} height={40} />
                  </Grid>
                  <Grid md={10} lg={10} xs={10} sm={10}>
                    <Grid container >
                      <Grid md={12} lg={12} xs={12} sm={12}>
                        <Skeleton animation="wave" />
                      </Grid>
                      <Grid md={12} lg={12} xs={12} sm={12}>
                        <Skeleton animation="wave" />
                      </Grid>
                    </Grid>

                  </Grid>
                </Grid>
              </Box>
              <Box mt={1} >
                <Grid container >
                  <Grid md={2} lg={2} xs={2} sm={2}>
                    <Skeleton variant="circle" width={40} height={40} />
                  </Grid>
                  <Grid md={10} lg={10} xs={10} sm={10}>
                    <Grid container >
                      <Grid md={12} lg={12} xs={12} sm={12}>
                        <Skeleton animation="wave" />
                      </Grid>
                      <Grid md={12} lg={12} xs={12} sm={12}>
                        <Skeleton animation="wave" />
                      </Grid>
                    </Grid>

                  </Grid>
                </Grid>
              </Box>

            </Box> :

              <Box>
                {outlets.length == 0 && "No outlet assigned to this user"}
                <List width="100%">
                  {outlets.map((r) => {
                    return <ListItem>
                      <ListItemAvatar>
                        <AmpStories fontSize="large" />
                      </ListItemAvatar>
                      <ListItemText primary={r['name']} secondary={r['location']['name']} />
                    </ListItem>;
                  })}



                </List>
              </Box>


            }

          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setOutletDialog(false);
          }} variant="outlined" color="secondary" >
            Close
          </Button>

        </DialogActions>
      </Dialog>




      {/* add new POS User  */}



      <Dialog
        maxWidth="sm"
        minHeight={200}
        fullWidth
        open={dialogStep}
        onClose={() => {
          setDialogStep(false);
          setActiveStep(0);
          setPosStep(0);
          setNID({ value: "", error: "" });
          setManually(false);
        }}
        aria-labelledby="new_user"
        aria-describedby="new_user"
      >
        <DialogTitle id="new_user">Add POS User</DialogTitle>
        <DialogContent>
          <DialogContentText >
            {posStep == 0 &&
              <Box>

                <Box>
                  <Box display="flex" justifyContent="center">
                    <img src={ID} width="100" height="100" />
                  </Box>
                  <Box display="flex" justifyContent="center">
                    <Typography color="secondary">Please enter NID</Typography>
                  </Box>
                  <Box mt={1} display="flex" justifyContent="center">
                    <TextField
                      autoFocus
                      size='small'
                      variant='outlined'
                      error={NID.error !== ""}
                      helperText={NID.error}
                      value={NID.value}

                      onChange={(e) => {
                        var data = e.target.value;
                        setNID({ value: data, error: "" });

                      }}

                      // InputProps={{
                      //   inputComponent: TextMaskCustom,
                      //   onChange: (e)=>{
                      //     var data=e.target.value.replace(" ","");
                      //     setNID({value:data,error:""});

                      //     // setScheduleTime({value:e.target.value,error:""});
                      //   },
                      // }}

                      label={"National ID"}
                      color='primary' fullWidth />
                  </Box>

                  <Box mt={1} display="flex" justifyContent="left">
                    <Button style={{ textTransform: "capitalize" }} color="primary" onClick={() => {
                      setManually(true);
                      setPosStep(1);
                    }}>
                      Continue Manually?
                    </Button>
                  </Box>

                </Box>
              </Box>

            }


            {posStep == 1 &&

              <Box>

                {manually == false &&
                  <Box>
                    <Grid container>
                      <Grid item xs={6} md={12} lg={12} sm={12}>
                        <Box display="flex" justifyContent="center">
                          <StyledBadge
                            overlap="circle"
                            anchorOrigin={{
                              vertical: 'bottom',
                              horizontal: 'right',
                            }}
                            variant="dot"
                          >
                            <Avatar src={"data:image/png;base64," + photo} style={{ width: "100px", height: "100px" }} />
                          </StyledBadge>

                        </Box>
                      </Grid>
                      <Grid item xs={12} md={12} lg={12} sm={12}>
                        <Box display="flex" justifyContent="center">
                          <Typography size="small">{Fname.value}</Typography>
                          <Typography size="small">{Lname.value}</Typography>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>


                }

                <Stepper activeStep={activeStep} alternativeLabel>


                  {steps.map((label) => (
                    <Step key={label}>
                      <StepLabel>{label}</StepLabel>
                    </Step>
                  ))}


                </Stepper>
                <Box>
                  {activeStep === steps.length ? (
                    <Box>
                      <Typography >All steps completed</Typography>
                      <Button onClick={handleReset}>Reset</Button>
                    </Box>
                  ) : (
                    <Box>
                      <Typography >


                        {/* {getStepContent(activeStep)} */}
                        {
                          activeStep == 0 &&

                          <Box>

                            <Box mt={1}>
                              <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>

                                <TextField size="small" variant='outlined' label={"Firstname"}
                                  error={Fname.error != ""}
                                  helperText={Fname.error}
                                  value={Fname.value}
                                  onChange={(e) => {
                                    if (e.target.value == "") {
                                      setFname({ value: "", error: "Enter firstname" });
                                    } else {
                                      setFname({ value: e.target.value, error: "" })
                                    }
                                  }}
                                  color='primary' fullWidth />
                              </FormControl>
                            </Box>


                            <Box mt={1}>
                              <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>

                                <TextField size="small" variant='outlined' label={"Lastname"}
                                  error={Lname.error != ""}
                                  helperText={Lname.error}
                                  value={Lname.value}
                                  onChange={(e) => {
                                    if (e.target.value == "") {
                                      setLname({ value: "", error: "Enter lastname" });
                                    } else {
                                      setLname({ value: e.target.value, error: "" })
                                    }
                                  }}
                                  color='primary' fullWidth />
                              </FormControl>
                            </Box>




                            <Box mt={1}>
                              <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>

                                <TextField size="small" variant='outlined' label={"Username"}
                                  error={userName.error != ""}
                                  helperText={userName.error}
                                  onChange={(e) => {
                                    if (e.target.value == "") {
                                      setUsername({ value: "", error: "Enter username" });
                                    } else {
                                      setUsername({ value: e.target.value, error: "" })
                                    }
                                  }}
                                  color='primary' fullWidth />
                              </FormControl>
                            </Box>



                            <Box mt={1}>
                              <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>

                                <TextField size="small" variant='outlined' label={"Email"}
                                  error={email.error != ""}
                                  helperText={email.error}
                                  onChange={(e) => {
                                    if (e.target.value == "") {
                                      setEmail({ value: "", error: "Enter email" });
                                    } else {
                                      setEmail({ value: e.target.value, error: "" })
                                    }
                                  }}
                                  color='primary' fullWidth />
                              </FormControl>
                            </Box>



                            <Box mt={1}>
                              <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>

                                <TextField size="small" variant='outlined' label={"Phone"}
                                  error={phone.error != ""}
                                  helperText={phone.error}
                                  onChange={(e) => {
                                    if (e.target.value == "") {
                                      setPhone({ value: "", error: "Enter phone" });
                                    } else {
                                      setPhone({ value: e.target.value, error: "" })
                                    }
                                  }}
                                  color='primary' fullWidth />
                              </FormControl>
                            </Box>

                            {manually == true &&
                              <Box mt={1}>
                                <FormControl size="small" type="number" variant="outlined" fullWidth className={classes.formControl}>

                                  <TextField size="small" variant='outlined' label={"NID"}
                                    error={NID.error != ""}
                                    helperText={NID.error}
                                    onChange={(e) => {
                                      if (e.target.value == "") {
                                        setNID({ value: "", error: "Enter NID" });
                                      } else {
                                        setNID({ value: e.target.value, error: "" })
                                      }
                                    }}
                                    color='primary' fullWidth />
                                </FormControl>
                              </Box>
                            }



                            {manually == true &&
                              <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
                                <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
                                  <InputLabel htmlFor="gender">Gender</InputLabel>
                                  <Select
                                    size="small"
                                    helperText={gender.error}
                                    label="Select gender"
                                    inputProps={{
                                      name: 'gender',
                                      id: 'gender',
                                    }}
                                    error={gender.error !== ""}
                                    onChange={(e) => {
                                      if (e.target.value === '') {
                                        setGender({ value: "", error: "Select gender" });
                                      } else {
                                        setGender({ value: e.target.value, error: "" });
                                      }
                                    }}
                                  >
                                    <MenuItem value="">
                                      <em>None</em>
                                    </MenuItem>
                                    <MenuItem value={"MALE"}>MALE</MenuItem>
                                    <MenuItem value={"FEMALE"}>FEMALE </MenuItem>
                                  </Select>
                                  <FormHelperText error={gender.error !== ""}>{gender.error}</FormHelperText>
                                </FormControl>
                              </Box>
                            }






                            <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
                              <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
                                <InputLabel htmlFor="tole">User role</InputLabel>
                                <Select
                                  size="small"
                                  helperText={role.error}
                                  label="Select User role"
                                  inputProps={{
                                    name: 'role',
                                    id: 'role',
                                  }}
                                  error={role.error !== ""}
                                  onChange={(e) => {
                                    if (e.target.value === '') {
                                      setRole({ value: "", error: "Select user role" });
                                    } else {
                                      setRole({ value: e.target.value, error: "" });
                                    }
                                  }}
                                >
                                  <MenuItem value="">
                                    <em>None</em>
                                  </MenuItem>
                                  {roles.map((r) => {
                                    return <MenuItem value={r['role_id']}>{r['name']}</MenuItem>;
                                  })}

                                </Select>
                                <FormHelperText error={role.error !== ""}>{role.error}</FormHelperText>
                              </FormControl>
                            </Box>


                            {/* 
<Box mt={1} display='flex' alignItems='center' justifyContent='center'>
<FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
<InputLabel htmlFor="type">User Type</InputLabel>
<Select
size="small"
helperText={userType.error} 
label="Select User Type"
inputProps={{
  name: 'type',
  id: 'type',
}}
error={userType.error!==""}
onChange={(e)=>{
  if(e.target.value===''){
    setUserType({value:"",error:"Select user type"});
  }else{
    setUserType({value:e.target.value,error:""});
  }
}}
>
  <MenuItem value="">
    <em>None</em>
  </MenuItem>

  <MenuItem value={"ORG_USER"}>Organization User</MenuItem>
  <MenuItem value={"POS_USER"}>POS User</MenuItem>

</Select>
<FormHelperText error={userType.error!==""}>{userType.error}</FormHelperText>
</FormControl>
</Box> */}

                            {/* <Box mt={1}>
<FormControl fullWidth  size="small"
variant="outlined">
  <InputLabel  htmlFor="password">Password</InputLabel>
  <OutlinedInput
  size="small"
    id="password"
    error={password.error!=""}
helperText={password.error}
    type={showPassword ? 'text' : 'password'}
    value={password.value}
    onChange={(e)=>{
      if(e.target.value==""){
        setPassword({value:"",error:"Enter valid password"});
      }else{
        setPassword({value:e.target.value,error:""});
      }
    }}
    endAdornment={
      <InputAdornment position="end">
        <IconButton
          aria-label="toggle password visibility"
          onClick={()=>{
            showPassword==false?setShowPassword(true):setShowPassword(false);
            
          }}
          onMouseDown={(e)=>{
            e.preventDefault();
          }}
          edge="end"
        >
          {showPassword? <Visibility /> : <VisibilityOff />}
        </IconButton>
      </InputAdornment>
    }
    labelWidth={70}
  />
</FormControl>
</Box>
 */}



                          </Box>

                        }
                        {
                          activeStep == 1 &&
                          <Box>

                            <Box mt={1}>

                              <Autocomplete
                                id="routes"
                                options={route}
                                getOptionLabel={(option) => option.name}
                                size="small"
                                onChange={(event, newValue) => {
                                  if (newValue != null) {
                                    setRouteOutlet([]);
                                    setRouteOutletId({ value: 0, error: "" });
                                    get_route_outlet(newValue.id);
                                  }

                                }}



                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="outlined"
                                    label="Select route"
                                    placeholder="Route"
                                  />
                                )}
                              />
                            </Box>

                            <Box mt={1}>

                              <Autocomplete
                                id="routeOutlet"
                                options={routeOutlet}
                                getOptionLabel={(option) => option.outlet.name}
                                size="small"
                                error={routeOutlet != ""}
                                helperText={routeOutlet.error}
                                onChange={(event, newValue) => {
                                  console.log("new value", newValue);
                                  if (newValue != null) {
                                    setRouteOutletId({ value: newValue.id, error: "" });
                                  }

                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="outlined"
                                    label="Select outlet"
                                    placeholder="Route"
                                  />
                                )}
                              />
                            </Box>

                          </Box>

                        }

                      </Typography>

                      <Box mt={2}>
                        {/* <Button
        disabled={activeStep === 0}
        onClick={handleBack}
        
      >
        Back
      </Button> */}
                        <Button variant="contained" color="primary"

                          onClick={() => {
                            console.log("step", activeStep);
                            if (activeStep === 1) {
                              assign_user_route();
                            } else {
                              new_user();
                            }
                          }
                          }>
                          {activeStep === steps.length - 1 ? assignLoad ? <CircularProgress size={25} color="secondary" /> : 'Save' : newLoad ? <CircularProgress size={25} color="secondary" /> : 'Next'}
                        </Button>
                      </Box>
                    </Box>
                  )}
                </Box>

              </Box>



            }      </DialogContentText>
        </DialogContent>
        <DialogActions>

          <Button variant="outlined" className={classes.btn} onClick={() => {
            setDialogStep(false);
            setActiveStep(0);
            setPosStep(0);
            setNID({ value: "", error: "" });
            setManually(false);
          }} color="secondary" >
            Cancel
          </Button>

          {posStep == 0 &&
            <Button variant="contained" disableElevation color="primary" onClick={() => {
              get_infos();
            }}>
              {loadInfo ? <CircularProgress color="secondary" size={25} /> : "Continue"}
            </Button>
          }


        </DialogActions>
      </Dialog>



      {/* assign route to user  */}


      <Dialog
        maxWidth="sm"
        minHeight={200}
        fullWidth
        open={assignDialog}
        onClose={() => {
          setAssignDialog(false);
        }}
        aria-labelledby="route_user"
        aria-describedby="route_user"
      >
        <DialogTitle id="route_user">Add Routes to user</DialogTitle>
        <DialogContent>
          <DialogContentText >

            <Box>

              <Box mt={1}>

                <Autocomplete
                  id="outlets"
                  options={Ioutlets}
                  getOptionLabel={(option) => option.name}
                  size="small"
                  onChange={(event, newValue) => {
                    if (newValue != null) {
                      get_routes_per_outlet(newValue.id);
                      setOutletId({ value: newValue.id, error: "" });
                    } else {
                      setOutletId({ value: 0, error: "Select outlet" });
                    }
                  }}


                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Select outlet"
                      placeholder="Outlet"
                    />
                  )}
                />

              </Box>

              <Box mt={1}>

                <Autocomplete
                  multiple
                  id="routes"
                  options={routesOutlet}
                  getOptionLabel={(option) => option.name}
                  size="small"
                  error={routeIds.error != ""}
                  helperText={routeIds.error}
                  onChange={(event, newValue) => {
                    console.log("new value huhu", newValue);
                    if (newValue.length == 0) {
                      setRouteIds({ value: [], error: "Select route" })
                    } else {
                      var ids = [];
                      newValue.map((n) => {
                        ids.push(n['id']);
                      });
                      setRouteIds({ value: ids, error: "" });
                    }

                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Select routes"
                      placeholder="Routes"
                    />
                  )}
                />
                {loadRoute && <LinearProgress color="primary" />}
              </Box>

            </Box>

          </DialogContentText>

        </DialogContent>
        <DialogActions>

          <Button
            onClick={() => {
              setAssignDialog(false);
            }}
          >
            Cancel
          </Button>
          <Button variant="contained" color="primary"

            onClick={() => {
              assign_routes();
            }
            }>
            {assignMoreLoad ? <CircularProgress size={25} color="secondary" /> : 'Add'}
          </Button>

        </DialogActions>
      </Dialog>

      {/* reset password  */}



      <Dialog
        maxWidth="sm"
        fullWidth
        open={resetDialog}
        onClose={() => {

          setResetDialog(false);

        }}
        aria-labelledby="reset_password"
        aria-describedby="reset_password"
      >
        <DialogTitle id="reset_password">{"Reset Password"}</DialogTitle>
        <DialogContent>
          <DialogContentText >
            <Box>
              {success == true && <Typography>{resetMessage}</Typography>}
              {success == false && <Typography>Are you sure you want to reset password of this user</Typography>}
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>

          <Button onClick={() => {


            setResetDialog(false);

          }} color="secondary" variant="outlined" >
            close
          </Button>

          {success == false &&
            <Button color="primary" onClick={() => {

              reset_password();

            }} variant="contained" >
              {resetLoad ? <CircularProgress size={25} color="secondary" /> : "Yes"}
            </Button>
          }


        </DialogActions>
      </Dialog>




    </div>
  );
}

export default withLocalize(UserRoute);